export const isExpired = (expirationDate) => {
    // Convertir la date d'expiration en objet Date
    const expiration = new Date(expirationDate);
    // Obtenir la date et l'heure actuelles
    const now = new Date();
    // Comparer les deux dates
    return expiration < now;
  }




  